import React from 'react';
import classNames from 'classnames';
import s from './Card.scss';

function iconType(iconSize, iconClassName, cardImageIcon, iconData) {
  switch (iconSize) {
    case 'primestory': {
      return <i className={s.toiplusIcon} />;
    }
    case 'primestorySmall': {
      return <i className={`${s.toiplusIcon} ${s.small} `} />;
    }
    case 'largeIcon': {
      return <i className={iconClassName}>{iconData || ''}</i>;
    }
    case 'smallIcon': {
      return <i className={cardImageIcon} />;
    }
    case 'payperstorytxt': {
      return (
        <i
          className={iconClassName}
          dangerouslySetInnerHTML={{
            __html: iconData || '',
          }}
        />
      );
    }
    default: {
      return null;
    }
  }
}

function Icon(
  isPhotoStory,
  isTypeVideo,
  duration,
  photosCount,
  isInlineSmallIconCard,
  isMobileInlineVideo,
  isToiPlusStory,
  isPaperStoryText,
  payPerTxt,
  showPriceTag,
  priceTag,
  isTOIPLeadImage,
) {
  let iconData = '';
  let iconSize;
  const iconClassName = classNames({
    //provides layout;
    [s.mediavideothumb]: isTypeVideo,
    [s.mediaphotothumb]: isPhotoStory,
    [s.payperstorystyle]: isPaperStoryText || showPriceTag,
  });

  const cardImageIcon = classNames({
    [s.newsVideo]: isTypeVideo,
    [s.newsPhoto]: isPhotoStory,
  });

  if (isPhotoStory) {
    iconData = photosCount;
  } else if (isTypeVideo) {
    iconData = duration;
  }
  if (isPaperStoryText) {
    iconData = payPerTxt;
  }
  if (showPriceTag) {
    iconData = priceTag;
  }
  if (isTOIPLeadImage && showPriceTag) {
    iconSize = 'payperstorytxt';
  } else if (!isInlineSmallIconCard) {
    if (isToiPlusStory) {
      iconSize = 'primestory';
      if (isPaperStoryText) {
        iconSize = 'payperstorytxt';
      }
    } else {
      iconSize = 'largeIcon';
    }
  } else if (isMobileInlineVideo || isInlineSmallIconCard) {
    if (isToiPlusStory) {
      iconSize = 'primestorySmall';
      if (isPaperStoryText) {
        iconSize = 'payperstorytxt';
      }
    } else {
      iconSize = 'smallIcon';
    }
  }

  return <>{iconType(iconSize, iconClassName, cardImageIcon, iconData)}</>;
}

export default Icon;
